import { isValidObjectId } from 'react-scale/components/design-system/ObjectIdInput/ObjectIdInput';
import { autoOpsCards } from '@scale/genai-compass-shared/autoops/cards';
import { ParameterType, ValueType } from '@scale/shared/types/execution';
import { StepConfiguration } from '@scale/shared/types/ruleEngine/step';
import { columnsFromRecord } from '@scale/compass-shared/utils';

export class DataCompassUtils {
  static mongoIdColumns = () =>
    // card: CardInfo,
    // includeMongoIdList: boolean = false,
    // defaultValues: any[] = [],
    {
      // const currentColumns = card.internal.columns ?? [];
      // const data = card.internal.data ?? [];

      // const likelyColumns = [];

      // for (const column of currentColumns) {
      //   let likelyWorkerId = true;
      //   for (const row of data) {
      //     if (
      //       !isValidObjectId(row[column.id ?? '']) &&
      //       !(includeMongoIdList && this.isValidObjectIdList(row[column.id ?? '']))
      //     ) {
      //       likelyWorkerId = false;
      //       break;
      //     }
      //   }

      //   if (likelyWorkerId) {
      //     likelyColumns.push(column);
      //   }
      // }

      // if (defaultValues.length > 0 && likelyColumns.length === 0) {
      //   return defaultValues;
      // }

      // return likelyColumns;
      return [];
    };

  static isValidObjectIdList(value: string) {
    if (!value) {
      return true;
    }
    if (typeof value !== 'string') {
      return false;
    }
    return value
      .split(',')
      .map(v => v.trim())
      .every(isValidObjectId);
  }

  static statusColumns = () =>
    // card: CardInfo, defaultValues: any[] = []
    {
      // const currentColumns = card.internal.columns ?? [];
      // const data = card.internal.data ?? [];
      // const likelyColumns = [];

      // for (const column of currentColumns) {
      //   let isStatusColumn = true;
      //   let hasStatusValue = false;

      //   for (const row of data) {
      //     const value = row[column.id ?? ''];
      //     const normalizedValue =
      //       typeof value === 'string'
      //         ? value
      //             .replace(/^"+|"+$/g, '')
      //             .toLowerCase()
      //             .trim()
      //         : String(value).toLowerCase().trim();

      //     if (normalizedValue !== '' && normalizedValue !== 'pass' && normalizedValue !== 'failed') {
      //       isStatusColumn = false;
      //       break;
      //     }

      //     if (normalizedValue === 'pass' || normalizedValue === 'failed') {
      //       hasStatusValue = true;
      //     }
      //   }

      //   if (isStatusColumn && hasStatusValue) {
      //     likelyColumns.push(column);
      //   }
      // }

      // if (defaultValues.length > 0 && likelyColumns.length === 0) {
      //   return defaultValues;
      // }

      // return likelyColumns;
      return [];
    };

  static maybeCleanNumberLikeValue(value: string): string {
    value = this.maybeCleanEmptyValue(value);
    value = this.maybeCleanNumberSuffix(value);
    value = this.maybeCleanNumberPrefix(value);
    return value;
  }

  private static maybeCleanEmptyValue(input: string): string {
    const EMPTY_VALUES = ['-'];
    return EMPTY_VALUES.includes(input) ? '' : input;
  }

  private static maybeCleanNumberSuffix(input: string): string {
    const SUFFIXES_TO_REMOVE = ['%'];
    for (const suffix of SUFFIXES_TO_REMOVE) {
      if (String(input).endsWith(suffix)) {
        const prefix: any = input.slice(0, -1);
        if (!isNaN(prefix)) {
          return prefix;
        }
      }
    }
    return input;
  }

  private static maybeCleanNumberPrefix(input: string): string {
    const PREFIXES_TO_REMOVE = ['L', '$'];
    for (const prefix of PREFIXES_TO_REMOVE) {
      if (String(input).startsWith(prefix)) {
        const suffix: any = input.slice(1);
        if (!isNaN(suffix)) {
          return suffix;
        }
      }
    }
    return input;
  }

  static getProcessedGenericAutoOpsStep<T extends keyof typeof autoOpsCards>(
    cardType: T,
    step: StepConfiguration<NonNullable<(typeof autoOpsCards)[T]['stepType']>>,
    retrievedOutput: { response?: { data: Record<string, any>[] } } | undefined,
  ) {
    if (!retrievedOutput || !retrievedOutput.response) {
      return step;
    }
    const shared = autoOpsCards[cardType as keyof typeof autoOpsCards];
    const objectIdFields = shared.objectIdFields;
    const data = retrievedOutput.response.data;
    const columns = columnsFromRecord(data).map(column => column.id);
    if (
      typeof step.parameterTypes === 'object' &&
      step.parameterTypes !== undefined &&
      step.parameterTypes !== null
    ) {
      Object.keys(step.parameterTypes).forEach(key => {
        if (objectIdFields?.includes(key)) {
          step.parameterTypes[key] = {
            type: ParameterType.Single,
            label: step.parameterTypes[key].label,
            valueType: ValueType.String,
            options: columns.map(column => ({ label: column, value: column })),
          };
        } else if (
          step.parameterTypes[key].valueType === ValueType.Boolean &&
          step.parameterTypes[key].type === ParameterType.Single
        ) {
          step.parameterTypes[key] = {
            ...step.parameterTypes[key],
            type: ParameterType.Single,
            valueType: ValueType.Boolean,
            value:
              step.parameterTypes[key].value !== undefined
                ? Boolean(step.parameterTypes[key].value)
                : false,
          };
        }
      });
    }
    return step;
  }
}
